<template>
  <div id="mobileInfo">
    <v-layout
      v-if="$vuetify.breakpoint.xs"
      row
    >
      <v-flex
        xs12
        class="mb-5"
      >
        <div
          v-cloak
          class="my-0 mx-auto iphone_mock text-sm-center"
          style="position:relative;width:217px;"
          v-html="store.mockup"
        />
      </v-flex>
    </v-layout>

    <!-- For now, UX has requested to remove this floating banner. It has lots of issues
    and they'd prefer to just remove it until we can push a comprehensive change.
                                                                  Josh Menden 6/5/18 -->

    <!-- <v-footer
      v-if="showBanner"
      :class="{'hidden-md-and-up': (store.loanPurpose === null), 'hidden-sm-and-up': (store.loanPurpose !== null)}"
      :style="{'margin-top': ($vuetify.breakpoint.sm ? '10vw' : '-65vw'),'margin-bottom': ($vuetify.breakpoint.sm ? '5vw' : '30vw')}"
      class="white--text pt-4 pb-4"
      color="primary"
      style="position:relative;left:50%;z-index:2;margin-left:-50vw;margin-right:-50vw;width:100vw;min-height:130px"
    >
      <v-layout row>
        <v-flex xs2><v-icon
          class="hoverable white--text"
          @click="showBanner=!showBanner">mdi-close</v-icon></v-flex>
        <v-flex
          xs8
          class="title">Securely scan & calculate easily on our mobile app. Download now.</v-flex>
        <v-flex
          xs2
          class="text-xs-right text-sm-right"><v-icon
            x-large
            class="hoverable white--text"
            @click="goToInstallLink()">mdi-download</v-icon></v-flex>
      </v-layout>
    </v-footer> -->

    <v-layout
      wrap
      row
      class="mt-5 hidden-sm-and-up"
    >
      <v-flex
        xs12
        sm4
        offset-sm4
        class="text-xs-center"
      >
        <img
          v-if="userAgent === 'Android' || userAgent === 'unknown'"
          alt="Google Play Store logo"
          :src="googlePlay"
          class="hoverable"
          style="height:60px;"
          @click="goToInstallLink()"
        >
        <br>
        <img
          v-if="userAgent === 'iOS' || userAgent === 'unknown'"
          alt="Apple App Store logo"
          :src="appleStore"
          class="hoverable"
          style="height:60px;"
          @click="goToInstallLink()"
        >
      </v-flex>
    </v-layout>

    <v-layout
      v-if="store.borrowerWebContent"
      :class="{'mt-3': $vuetify.breakpoint.smAndDown}"
      class="mb-0"
      row
    >
      <v-flex
        :class="{'pr-5': $vuetify.breakpoint.mdAndUp, 'py-4': $vuetify.breakpoint.smAndDown}"
        md8
        xs12
      >
        <v-flex
          md10
          xs12
        >
          <h4
            :class="{'display-2': $vuetify.breakpoint.mdAndUp, 'display-1': $vuetify.breakpoint.smAndDown}"
            class="light accent--text"
          >
            {{ store.borrowerWebContent.splashMobileHeader }}
          </h4>
          <h6 class="subheading light accent--text mt-4 mb-4">
            {{ store.borrowerWebContent.splashMobileSubheader }}
          </h6>
          <ul style="list-style-type:none;">
            <template v-for="(bullet, index) in store.borrowerWebContent.splashMobileBullets">
              <li
                :key="'mobileBullet-' + index"
                :class="{'mb-3': $vuetify.breakpoint.smAndDown}"
                style="line-height:1.5em"
              >
                <v-layout
                  class="mb-3"
                  row
                >
                  <v-flex
                    :class="{'mr-4': $vuetify.breakpoint.smAndDown}"
                    xs1
                  >
                    <v-icon
                      style="font-size: 48px;"
                      class="accent--text mt-1"
                    >
                      {{ $vuetify.icons['sn-icon-check-circle'] }}
                    </v-icon>
                  </v-flex>
                  <v-flex
                    :class="{'ml-3':$vuetify.breakpoint.smAndDown, 'ml-4': $vuetify.breakpoint.mdAndUp}"
                    class="body-1 light mt-2 pt-2"
                    xs10
                  >
                    {{ bullet }}
                  </v-flex>
                </v-layout>
              </li>
            </template>
          </ul>
        </v-flex>
      </v-flex>
      <v-flex
        sm4
        md4
        class="hidden-xs-only mt-5"
      >
        <img
          :src="phoneFullScanner"
          alt="phone full scanner"
          style="max-width:70%;"
        >
      </v-flex>
    </v-layout>

    <v-layout
      id="shareApp"
      row
      :class="{'justify-center mb-3':$vuetify.breakpoint.smAndDown }"
    >
      <v-flex
        :class="{'xs6':$vuetify.breakpoint.smAndUp, 'xs12':$vuetify.breakpoint.smAndDown }"
        class="mt-3"
      >
        <borrower-share-app-by-sms />
      </v-flex>
    </v-layout>

    <v-layout
      v-if="$vuetify.breakpoint.sm"
      class="mt-5 mb-5"
      row
      justify-center
    >
      <v-flex
        v-if="userAgent === 'Android' || userAgent === 'unknown'"
        class="text-xs-center"
        xs6
      >
        <img
          class="hoverable"
          :src="googlePlay"
          style="height:60px;"
          @click="goToInstallLink()"
        >
      </v-flex>
      <v-flex
        v-if="userAgent === 'iOS' || userAgent === 'unknown'"
        class="text-xs-center"
        xs6
      >
        <img
          class="hoverable"
          :src="appleStore"
          style="height:60px;"
          @click="goToInstallLink()"
        >
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import borrowerShareAppBySms from './borrowerShareAppBySms'
import phoneFullScanner from '~/assets/images/mockup/phone_full_scanner.png'
import googlePlay from '~/assets/images/google_play.png'
import appleStore from '~/assets/images/apple_store.png'
export default {
  name: 'MobileInfo',
  components: {
    borrowerShareAppBySms: borrowerShareAppBySms
  },
  data () {
    return {
      showBanner: true,
      store: this.$store,
      googlePlay: googlePlay,
      appleStore: appleStore,
      phoneFullScanner: phoneFullScanner
    }
  },
  computed: {
    userAgent () {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera

      if (/windows phone/i.test(userAgent)) {
        return 'Windows Phone'
      } else if (/android/i.test(userAgent)) {
        return 'Android'
      } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return 'iOS'
      }

      return 'unknown'
    }
  },
  methods: {
    goToInstallLink () {
      window.location.replace(`/install/app/${this.store.activationCode}?skip_mobile_signup=1`)
    }
  }
}
</script>

<style scoped>
</style>
